// src/lib/dexie/mediaCacheUtils.ts

import { mediaCacheDB, CachedMedia } from "./db";

// Store the actual decrypted bytes (Blob), not a blob URL
export const saveMediaToCache = async (
  messageId: number,
  mediaType: CachedMedia["mediaType"],
  blob: Blob,
  mimeType?: string
) => {
  await mediaCacheDB.cachedMedia.put({
    messageId,
    mediaType,
    blob,
    mimeType: mimeType ?? blob.type,
    updatedAt: Date.now(),
  });
};

// Retrieve Blob and create an object URL on demand
export const getMediaFromCache = async (
  messageId: number
): Promise<{ blob: Blob; mimeType?: string } | undefined> => {
  const row = await mediaCacheDB.cachedMedia.get(messageId);
  if (row?.blob) {
    return { blob: row.blob, mimeType: row.mimeType };
  }
  return undefined;
};

export const deleteMediaFromCache = async (messageId: number) => {
  await mediaCacheDB.cachedMedia.delete(messageId);
};

// Cleanup entries older than 7 days
const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;
export const cleanOldCachedMedia = async () => {
  const now = Date.now();
  const all = await mediaCacheDB.cachedMedia.toArray();
  for (const row of all) {
    if (now - row.updatedAt > SEVEN_DAYS_MS) {
      await mediaCacheDB.cachedMedia.delete(row.messageId);
    }
  }
};

// ✅ friendly aliases (new API)
export const cacheDecryptedMedia = saveMediaToCache;

// Return a fresh blobUrl; caller should revoke when no longer needed
export const getDecryptedMediaFromCache = async (messageId: number) => {
  const cached = await getMediaFromCache(messageId);
  if (!cached) return null;
  const url = URL.createObjectURL(cached.blob);
  return { blobUrl: url, mimeType: cached.mimeType };
};

